/**
 * Returns formatted price with currency
 */
export const price = (
    value: number,
    currency?: string | null | undefined,
    showEmptyFractions = false,
    rounding = false,
): string => {
    const hasFraction = value - Math.floor(value) > 0;

    return new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: currency ?? 'PLN',
        maximumFractionDigits: rounding ? 0 : !hasFraction && !showEmptyFractions ? 0 : 2,
    })
        .format(value)
        .replace(',', '.');
};

export const lowerCaseString = (service?: string) =>
    service && service.charAt(0).toLowerCase() + service.slice(1);

export const formatUsername = (name: string) => {
    const lowercaseWords = new Set(['i', 'a', 'oraz', 'z', 'ze', 'w', 'na', 'do', 'od', 'and', 'or', 'of', 'the', 'in', 'on', 'at', 'to', 'for', 'with']);
    
    const capitalizeWord = (word: string, isFirstWord = false): string => {
        if (isFirstWord || !lowercaseWords.has(word.toLowerCase())) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }
        return word.toLowerCase();
    };

    const processWordPart = (part: string, isFirstWord = false): string => {
        if (part.includes('-')) {
            return part
                .split('-')
                .map((hyphenPart, index) => capitalizeWord(hyphenPart, isFirstWord && index === 0))
                .join('-');
        }
        return capitalizeWord(part, isFirstWord);
    };

    return name
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word, index) => {
            const isFirstWord = index === 0;
            if (word.includes("'")) {
                return word
                    .split("'")
                    .map((part, partIndex) => processWordPart(part, isFirstWord && partIndex === 0))
                    .join("'");
            }
            return processWordPart(word, isFirstWord);
        })
        .join(' ');
};
